import DictType from './DictType.js';
import Dictionary from './Dictionary.js';
import ConditionAnalyzer from './ConditionAnalyzer.js';
import ReferenceTest from './ReferenceTest.js';
import RemoteCenter from '../remoteservice/RemoteCenter.js';
import ModuleCenter from '../datamodule/ModuleCenter.js';

const like = function(target, value) {
    return value.test(target);
}

const insetof = function(target, value) {
    return value[target] !== undefined;
}

const test = function(target, opt, value, not, ignocase) {
    switch (opt) {
        case '==':
            if (ignocase) return not ? (target + "").toLowerCase() != (value + "").toLowerCase() : (target + "").toLowerCase() == (value + "").toLowerCase();
            else return not ? target != value : target == value;
        case '>':
            return not ? target <= value : target > value;
        case '<':
            return not ? target >= value : target < value;
        case '>=':
            return not ? target < value : target >= value;
        case '<=':
            return not ? target > value : target <= value;
        case '!=':
            if (ignocase) return not ? (target + "").toLowerCase() == (value + "").toLowerCase() : (target + "").toLowerCase() != (value + "").toLowerCase();
            else return not ? target == value : target != value;
        case 'like':
            return not ? !like(target, value) : like(target, value);
        case 'in':
            return not ? !insetof(target, value) : insetof(target, value);
        case 'is null':
            return not ? target !== null : target === null;
    }
}
const cross = function(target, datas) {
    for (var i in target) {
        if (datas[i] === undefined) delete target[i];
    }
    return target;
}
const union = function(target, datas) {
    for (var i in datas) {
        if (target[i] === undefined) target[i] = datas[i];
    }
    return target;
}

//为基础字典扩展动态处理部分

const removeByKeys = function(keys) {
    this._dict.removeByKeys(keys);
}
const mapDatas = (datas, map, dataInfo)=> {
    if (!datas) return [];
    const result = [];
    for (const data of datas) {
        if (data.status == '3') continue;
        const d = {};
        for (const [mapField, field] of Object.entries(map)) {
            d[mapField] = '' + (data[field] == null ? '' : data[field]);
        }
        const children = dataInfo.getChildren(data);
        if (children) {
            d.children = mapDatas(children, map, dataInfo);
        }
        result.push(d);
    }
    return result;
}

class DataInfo {
    _dict = null;
    _loaded = false;
    _dictType = null;
    _dataUrl = null;
    _queryUrl = null;
    _listUrl = null;
    _maxDynamicSize = 0;
    _expire = null;

    _keyList = null;
    _childrenKeyField = null;
    _parentKeyField = null;
    _childrenField = null;
    _parentKeyMap = {};
    _childrenKeyMap = {};
    
    _mergeInfo = null;

    constructor(code, config, datas) {
        this._code = code;
        if (!config.fields) { 
            console.log('erroe config:', code, config);
        }
        this._exps = config.fields ? this.getExps(config.fields) : null;
        if (datas) this.calculateExps(datas);
        this._refCode = config.refCode;
        this._gateway = config.gateway;
        this._apiVersion = config.apiVersion;
        this._dict = new Dictionary(config, datas);
        this._treeInfo = config.treeInfo;
        this._jsonFields = config.jsonFields;
        if (config.treeInfo) {
            if (config.dynamic) this._dictType = DictType.DYNAMICTREE;
            else this._dictType = DictType.TREE;
        } 
        else 
        this._dictType = config.dictType != null ? config.dictType : DictType.DYNAMIC;
        if (this._treeInfo) {
            this._parentKeyField = this._treeInfo.parentField;
            this._childrenKeyField = this._treeInfo.keyField;
        }
        this._maxDynamicSize = this._dictType == DictType.DYNAMIC ? config.maxSize || 1000 : 0;
        this._dataUrl = config.dataUrl;
        this._queryUrl = config.queryUrl;
        this._listUrl = config.listUrl;
        this._method = config.method || 'POST',
        this._expire = config.expire;
        if (this._dictType == DictType.STATIC) {
            if (datas && datas.length) {
                this.initKeyList(datas);
                this._loaded = true;
            } else {
                this._loaded = false;
            }
        } else if (this._dictType == DictType.TREE || this._dictType == DictType.DYNAMICTREE) {
            if (datas && datas.length) {
                this.initKeyList(datas);
                this._loaded = true;
            } else {
                this._loaded = false;
            }
        } else if (this._maxDynamicSize > 0) {
            this._referenceTest = new ReferenceTest(this._maxDynamicSize, removeByKeys.bind(this));
        }
        // this._merge = config.merge;
        // if (config.merge && datas && datas.length) {
        //     this.merge(datas, config.merge);
        // }
    }

    getExps(fields) {
        const exps = [];
        for (const field of fields) {
            if (field.exp) {
                exps.push(new Function('data', 'return data.' + field.code + ' = (' + field.exp + ')'));
            }
        }
        return exps;
    }
    calculateExps(datas) {
        const exps = this._exps;
        if (exps && exps.length) {
            for (const data of datas) {
                for (const exp of exps) {
                    exp(data);
                }
            }
        }
    }

    async setMergeInfo(mergeInfo) {
        this._mergeInfo = mergeInfo;
        if (this._keyList && this._keyList.length) {
            const datas = this.getDatas();
            await this.merge(datas, mergeInfo);
        }
    }
    async setDynamicMergeInfo(mergeInfo) {
        this._dynamicMergeInfo = mergeInfo;
    }

    async merge(datas, merge) {
        for (const [code, mergeInfo] of Object.entries(merge)) {
            const {relModule, srcField, destField, fields} = mergeInfo;
            const values = [];
            for (const data of datas) {
                const d = data[srcField];
                if (d != null) values.push(d);
            }
            if (values.length) {
                const df = relModule.getDataField(destField);
                const relDatas = df.isForeignKey() ? await relModule.getByIndices(values, destField) : await relModule.getByKeys(values, destField);
                this.mergeDatas(relDatas, srcField, destField, fields);
            }
        }
        // console.log('merge end', datas);
    }
    async dynamicMerge(datas, parentData) {
        if (!this._dynamicMergeInfo) return datas;
        for (const [code, mergeInfo] of Object.entries(this._dynamicMergeInfo)) {
            const relModule = ModuleCenter.getModule(code);
            const queryParams = {query:{}, options:{}};
            for (const q of mergeInfo.query) {
                const values = [parentData[q.src]];
                queryParams.query[q.dest] = [q.path, values];
                queryParams.options[q.dest] = 'multi-relate';
            }
            const relDatas = await relModule.queryDatas(queryParams);
            let targetField;
            let field;
            if (/^(\w+)\:(\w+)$/.test(mergeInfo.on)) {
                targetField = RegExp.$1;
                field = RegExp.$2;
            } else {
                targetField = field = mergeInfo.on;
            }
            return this.mergeDatasOn(datas, relDatas, targetField, field, mergeInfo.fields, parentData, mergeInfo.parentMap, mergeInfo.default);
        }
        return datas;
    }
    mergeDatasOn(targetDatas, datas, targetField, field, fields, parentData, parentMap, defaultData) {
        const result = [];
        for (const data of datas) {
            const value = data[field];
            const r = Object.assign({}, defaultData);
            for (const f of fields) {
                r[f] = data[f];
            }
            r[field] = value;
            if (parentData && parentMap) {
                for (const [mapField, pField] of Object.entries(parentMap)) {
                    r[mapField] = parentData[pField];
                }
            }
            for (const targetData of targetDatas) {
                if (targetData[targetField] == value) {
                    Object.assign(r, targetData);
                    break;
                }
            }
            result.push(r);
        }
        return result;
    }
    mergeDatas(datas, srcField, destField, fields) {
        for (const relData of datas) {
            const value = relData[destField];
            const data = this.getDataLocal(value, srcField);
            if (data) {
                if (fields instanceof Array) {
                    for (const f of fields) {
                        data[f] = relData[f];
                    }
                } else if (fields instanceof Object) {
                    for (const [mf, f] of Object.entries(fields)) {
                        data[mf] = relData[f];
                    }
                }
            } else {
                const ds = this.getByIndicesLocal([value], srcField);
                if (ds) {
                    for (const d of ds) {
                        if (fields instanceof Array) {
                            for (const f of fields) {
                                d[f] = relData[f];
                            }
                        } else if (fields instanceof Object) {
                            for (const [mf, f] of Object.entries(fields)) {
                                d[mf] = relData[f];
                            }
                        }
                    }
                }
            }
        }
    }

    testKey(key) {
        if (!this._referenceTest) return;
        this._referenceTest.test(key);
    }
    testKeys(keys) {
        if (!this._referenceTest) return;
        for (const key of keys) {
            this.testKey(key);
        }
    }
    testData(data) {
        if (!this._referenceTest) return;
        this._referenceTest.test(this._dict.dataKey(data));
    }
    testDatas(datas) {
        if (!this._referenceTest) return;
        for (const data of datas) {
            this.testData(data);
        }
    }

    keyFields() {
        return this._dict.keyFields();
    }

    initKeyList(datas) {
        const keyList = [];
        if (!this._treeInfo) {
            for (const data of datas) {
                keyList.push(this._dict.dataKey(data));
            }
        } else {
            // const keys = [];
            const parentKeyMap = {};
            const childrenKeyMap = {};
            const keyField = this._treeInfo.keyField;
            this._dict._defaultKeyField = keyField;
            this._dict.updateIndexMaps();
            const parentField = this._treeInfo.parentField;
            const keymap = {};
            for (const data of datas) {
                const k = data[keyField];
                const pk = data[parentField];
                keymap[k] = 1;
                // delete badmap[k];
                if (pk) {
                    parentKeyMap[k] = pk;
                    let childrenKeys = childrenKeyMap[pk];
                    if (!childrenKeys) childrenKeys = childrenKeyMap[pk] = [k];
                    else childrenKeys.push(k);
                } else {
                    keyList.push(k);
                }
            }
            this._parentKeyMap = parentKeyMap;
            this._childrenKeyMap = childrenKeyMap;
        }
        this._keyList = keyList;
    }
    updateKeyList(datas) {
        const keyList = this._keyList || [];
        if (!this._treeInfo) {
            for (const data of datas) {
                keyList.push(this._dict.dataKey(data));
            }
        } else {
            // const keys = [];
            const parentKeyMap = this._parentKeyMap;
            const childrenKeyMap = this._childrenKeyMap;
            const keyField = this._treeInfo.keyField;
            const parentField = this._treeInfo.parentField;
            const keymap = {};
            for (const data of datas) {
                const k = data[keyField];
                const pk = data[parentField];
                keymap[k] = 1;
                // delete badmap[k];
                if (pk) {
                    parentKeyMap[k] = pk;
                    let childrenKeys = childrenKeyMap[pk];
                    if (!childrenKeys) childrenKeys = childrenKeyMap[pk] = [k];
                    else childrenKeys.push(k);
                } else {
                    keyList.push(k);
                }
            }
        }
    }

    getDictType() {
        return this._dictType;
    }

    getChildrenByKey(key) {
        const childrenKeys = this._childrenKeyMap[key];
        if (!childrenKeys) return null;
        const datas = [];
        for (const key of childrenKeys) {
            const data = this._dict.getData(key, this._childrenKeyField);
            datas.push(data);
        }
        return datas;
    }
    getParentByKey(key) {
        const parentKey = this._parentKeyMap[key];
        if (!parentKey) return null;
        return this._dict.getData(parentKey, this._dict.defaultKeyField());
    }
    getChildren(data) {
        const key = this._dict.dataKey(data, this._childrenKeyField);
        return this.getChildrenByKey(key);
    }
    getParent(data) {
        const key = this._dict.dataKey(data, this._dict.defaultKeyField());
        return this.getParentByKey(key);
    }

    defaultKeyField() {
        return this._dict.defaultKeyField();
    }
    dataKey(data, keyField) {
        return this._dict.dataKey(data, keyField);
    }
    datasKeys(datas, keyField) {
        return this._dict.datasKeys(datas, keyField);
    }

    compress(datas) {
        if (!datas) return;
        if (!(datas instanceof Array)) datas = [datas];
        if (this._jsonFields) {
            const entries = Object.entries(this._jsonFields);
            for (const data of datas) {
                for (const [jsonField, fields] of entries) {
                    try {
                        const d = {};
                        fields.map((field)=> d[field] = data[field])
                        data[jsonField] = JSON.stringify(d);
                    } catch(e) {}
                }
            }
        }
    }
    decompress(datas) {
        if (!datas) return;
        if (!(datas instanceof Array)) datas = [datas];
        if (this._jsonFields) {
            const entries = Object.entries(this._jsonFields);
            for (const data of datas) {
                for (const [jsonField, fields] of entries) {
                    try {
                        const d = JSON.parse(data[jsonField]);
                        if (d) fields.map((field)=> data[field] = d[field])
                    } catch(e) {}
                }
            }
        }
    }

    async resetDatas(datas) {
        this.calculateExps(datas);
        this.decompress(datas);
        this._dict.resetDatas(datas);
        if (this._dictType == DictType.STATIC) {
            if (datas && datas.length) {
                this.initKeyList(datas);
                this._loaded = true;
            } else {
                this._loaded = false;
            }
        } else if (this._dictType == DictType.TREE) {
            if (datas && datas.length) {
                this.initKeyList(datas);
                this._loaded = true;
            } else {
                this._loaded = false;
            }
        }
        if (this._mergeInfo && datas && datas.length) {
            await this.merge(datas, this._mergeInfo);
        }
    }
    async addDatas(datas) {
        this.calculateExps(datas);
        this.decompress(datas);
        this._dict.addDatas(datas);
        if (this._dictType == DictType.STATIC) {
            if (datas && datas.length) {
                this.updateKeyList(datas);
                this._loaded = true;
            }
        } else if (this._dictType == DictType.TREE) {
            if (datas && datas.length) {
                this.updateKeyList(datas);
                this._loaded = true;
            }
        }
        if (this._mergeInfo && datas && datas.length) {
            await this.merge(datas, this._mergeInfo);
        }
    }
    async updateDatas(datas, resetKeyList) {
        this.calculateExps(datas);
        this.decompress(datas);
        datas = this._dict.updateDatas(datas);
        if (this._dictType == DictType.TREE && resetKeyList) {
            if (datas && datas.length) {
                this.initKeyList(datas);
            }
        }
        if (this._mergeInfo && datas && datas.length) {
            await this.merge(datas, this._mergeInfo);
        }
        return datas;
    }

    getDatas() {
        if (!this._keyList) return [];
        const root = [];
        for (const key of this._keyList) {
            const data = this._dict.getData(key, this._childrenKeyField);
            // const children = this.getChildrenByKey(key);
            // if (children) {
            //     data.children = children;
            // }
            root.push(data);
        }
        return root;
    }

    async queryDatas(queryParams, keyData, pagination, extData) {
        switch (this._dictType) {
            case DictType.STATIC: {
                // load from local
                if (!this._loaded) {
                    const datas = await this.loadStaticDatas();
                    await this.resetDatas(datas);
                }
                return this.filter(queryParams.query, keyData);
            }
            case DictType.TREE: {
                const data = await this.queryRemote(queryParams, keyData, pagination, extData);
                return await this.updateDatas(data, !pagination);
            }
            default:
            case DictType.DYNAMIC: {
                // load from remote and update local
                const data = await this.queryRemote(queryParams, keyData, pagination, extData);
                return await this.updateDatas(data);
                // return data;
            }
        }
    }
    async queryDatasSilence(queryParams, keyData, pagination, extData) {
        switch (this._dictType) {
            case DictType.STATIC: {
                // load from local
                if (!this._loaded) {
                    const datas = await this.loadStaticDatas();
                    await this.resetDatas(datas);
                }
                return this.filter(queryParams.query, keyData);
            }
            case DictType.TREE: {
                const data = await this.queryRemote(queryParams, keyData, pagination, extData);
                return await this.updateDatas(data, !pagination);
            }
            default:
            case DictType.DYNAMIC: {
                // load from remote and update local
                const data = await this.queryRemote(queryParams, keyData, pagination, extData);
                return await this.updateDatas(data);
                // return data;
            }
        }
    }
    async queryDatasWithUrl(url, queryParams, keyData, pagination, extData) {
        switch (this._dictType) {
            case DictType.STATIC: {
                // load from local
                if (!this._loaded) {
                    const datas = await this.loadStaticDatasWithUrl(url);
                    await this.resetDatas(datas);
                }
                return this.filter(queryParams.query, keyData);
            }
            default:
            case DictType.DYNAMIC: {
                // load from remote and update local
                const data = await this.queryRemoteWithUrl(url, queryParams, keyData, pagination, extData);
                return await this.updateDatas(data);
                // return data;
            }
        }
    }

    getDataLocal(key, keyField) {
        return this._dict.getData(key, keyField);
    }
    getDatasLocal(keys, keyField) {
        return this._dict.getDatas(keys, keyField);
    }
    async getData(key, keyField) {
        switch (this._dictType) {
            case DictType.STATIC: {
                return this.getDataLocal(key, keyField);
            }
            case DictType.DYNAMIC: {
                const data = await this.loadRemote(key, keyField);
                return (await this.updateDatas([data]))[0];
                // return null;
            }
        }
    }
    async getDataWithUrl(url, key, keyField) {
        switch (this._dictType) {
            case DictType.STATIC: {
                return this.getDataLocal(key, keyField);
            }
            case DictType.DYNAMIC: {
                const data = await this.loadRemoteWithUrl(url, key, keyField);
                return await this.updateDatas([data]);
                // return data;
            }
        }
    }
    getByKeysLocal(keys, keyField) {
        return this._dict.getDatas(keys, keyField);
    }
    async getByKeys(keys, keyField) {
        switch (this._dictType) {
            case DictType.STATIC:
                // get from local
                if (!this._loaded) {
                    const datas = await this.loadStaticDatas();
                    // console.log('fill local datas', this._code, datas);
                    await this.resetDatas(datas);
                }
                return this.getByKeysLocal(keys, keyField);
            case DictType.TREE:
                // if (!this._loaded) {
                //     const ds = await this.loadStaticDatas();
                //     // console.log('fill local datas', this._code, ds);
                //     await this.resetDatas(ds);
                // }
                // return this.getByKeysLocal(keys, keyField);
            default:
            case DictType.DYNAMIC:
                const unusedKeys = this._dict.unusedKeys(keys, keyField);
                if (unusedKeys.length) {
                    // load from remote and update local
                    const datas = await this.loadRemoteByKeys(unusedKeys, keyField);
                    // console.log('fill local datas', this._code, datas);
                    if (datas) await this.addDatas(datas);
                }
                // get from local
                let datas = null;
                if (!keyField || this._dict.testKeyField(keyField)) datas = this._dict.getDatas(keys, keyField);
                else datas = this.match(keyField + ' in ' + JSON.stringify(keys));
                this.testDatas(datas);
                return await this.updateDatas(datas)
                // return datas;
        }
        return null;
    }
    getByIndicesLocal(indices, indexField) {
        return this._dict.getIndicesDatas(indices, indexField);
    }
    async getByIndices(indices, indexField) {
        switch (this._dictType) {
            case DictType.STATIC:
                return this.getByIndicesLocal(indices, indexField);
            case DictType.DYNAMIC:
                const datas = await this.loadRemoteByIndices(indices, indexField);
                // console.log('reset local datas', this._code, indexField, indices, datas);
                this._dict.resetIndexDatas(datas, indices, indexField);
                return this._dict.getIndicesDatas(indices, indexField);
        }
    }
    async createData(data) {
        this.compress(data);
        switch (this._dictType) {
            case DictType.STATIC: 
                break;
            default:
            case DictType.DYNAMIC:
                const d = await this.createRemoteData(data);
                if (d) this._dict.addData(d);
                return d;
                // break;
        }
    }
    async createDataWithUrl(url, data) {
        this.compress(data);
        switch (this._dictType) {
            case DictType.STATIC: 
                break;
            case DictType.DYNAMIC:
                const d = await this.createRemoteDataWithUrl(url, data);
                if (d) this._dict.addData(d);
                return d;
                // break;
        }
    }
    async createDatas(datas) {
        for (const data of datas) {
            this.compress(data);
        }
        switch (this._dictType) {
            case DictType.STATIC: 
                break;
            default:
            case DictType.DYNAMIC:
                const d = await this.createRemoteDatas(datas);
                // if (d) this._dict.addData(d);
                return d;
                // break;
        }
    }
    async editData(key, data, conf) {
        this.compress(data);
        let d = null;
        switch (this._dictType) {
            case DictType.STATIC:   
                d = await this.editRemoteData(data, conf);
                if (d) this._dict.updateData(key, d);
                return d;
                break;
            case DictType.TREE:
                d = await this.editRemoteData(data);
                if (d) this._dict.updateData(key, d);
                return d;
                break;
            default:
            case DictType.DYNAMIC:
                d = await this.editRemoteData(data);
                if (d) this._dict.updateData(key, d);
                return d;
                // break;

        }
    }
    async editDatas(datas) {
        for (const data of datas) {
            this.compress(data);
        }
        await this.editRemoteDatas(datas);
        this._dict.updateDatas(datas);
    }
    async editDataWithUrl(url, key, data) {
        this.compress(data);
        switch (this._dictType) {
            case DictType.STATIC: 
                break;
            case DictType.DYNAMIC:
                const d = await this.editRemoteDataWithUrl(url, data);
                if (d) this._dict.updateData(key, d);
                return d;
                // break;

        }
    }

    getSerivceCode() {
        const code = this._refCode || this._code;
        return this._gateway ? '../' + this._gateway + '/' + code : code;
    }
    async loadStaticDatas() {
        const ver = this._apiVersion || '';
        if (this._dataUrl) return RemoteCenter['loadDictDatasWithUrl' + ver](this._dataUrl);
        return RemoteCenter['loadDictDatas' + ver](this.getSerivceCode());
    }
    async loadStaticDatasWithUrl(url) {
        const ver = this._apiVersion || '';
        return RemoteCenter['loadDictDatasWithUrl' + ver](url);
    }
    async queryRemote(queryParams, keyData, pagination, extData) {
        const ver = this._apiVersion || '';
        if (this._queryUrl) return RemoteCenter['queryDatasWithUrl' + ver](this._queryUrl, queryParams, keyData, pagination, extData);
        return RemoteCenter['queryDatas' + ver](this.getSerivceCode(), queryParams, keyData, pagination, extData);
    }
    async queryRemoteSilence(queryParams, keyData, pagination, extData) {
        const ver = this._apiVersion || '';
        if (this._queryUrl) return RemoteCenter['queryDatasWithUrl' + ver](this._queryUrl, queryParams, keyData, pagination, extData);
        return RemoteCenter['queryDatas' + ver](this.getSerivceCode(), queryParams, keyData, pagination, extData);
    }
    async queryRemoteWithUrl(url, queryParams, keyData, pagination, extData) {
        const ver = this._apiVersion || '';
        return RemoteCenter['queryDatasWithUrl' + ver](url, queryParams, keyData, pagination, extData);
    }
    async loadRemote(key, keyField) {
        const ver = this._apiVersion || '';
        return RemoteCenter['getData' + ver](this.getSerivceCode(), key, keyField);
    }
    async getAllDatas() {
        const ver = this._apiVersion || '';
        return RemoteCenter['getAllDatas' + ver](this.getSerivceCode());
    }
    async loadRemoteWithUrl(url, key, keyField) {
        const ver = this._apiVersion || '';
        return RemoteCenter['getDataWithUrl' + ver](url, key, keyField);
    }
    async loadRemoteByKeys(keys, keyField) {
        const ver = this._apiVersion || '';
        if (this._listUrl) return RemoteCenter['getDatasByFieldWithUrl' + ver](this._listUrl, keyField || this._dict.defaultKeyField(), keys);
        return RemoteCenter['getDatasByField' + ver](this.getSerivceCode(), keyField || this._dict.defaultKeyField(), keys);
    }
    async loadRemoteByIndices(indices, indexField) {
        const ver = this._apiVersion || '';
        if (this._listUrl) return RemoteCenter['getDatasByFieldWithUrl' + ver](this._listUrl, indexField, indices);
        return RemoteCenter['getDatasByField' + ver](this.getSerivceCode(), indexField, indices);
    }
    async createRemoteData(data) {
        const ver = this._apiVersion || '';
        const d = await RemoteCenter['insertData' + ver](this.getSerivceCode(), data);
        return this.loadRemote(d.id, 'id');
    }
    async createRemoteDatas(datas) {
        const ver = this._apiVersion || '';
        const d = await RemoteCenter['insertDatas'](this.getSerivceCode(), datas);
        return d;
    }
    async createRemoteDataWithUrl(url, data) {
        const ver = this._apiVersion || '';
        return RemoteCenter['insertDataWithUrl' + ver](url, data);
    }
    async editRemoteData(data, conf) {
        const ver = this._apiVersion || '';
        return RemoteCenter['updateData' + ver](this.getSerivceCode(), data, conf);
    }
    async editRemoteDatas(datas) {
        return RemoteCenter['updateDatas'](this.getSerivceCode(), datas);
    }
    async editRemoteDataWithUrl(url, data) {
        const ver = this._apiVersion || '';
        return RemoteCenter['updateDataWithUrl' + ver](url, data);
    }
    async deleteDatasByKeys(keys) {
        const ver = this._apiVersion || '';
        return RemoteCenter['removeDatas' + ver](this.getSerivceCode(), keys);
    }
    async getNextData(data, filter) {
        const ver = this._apiVersion || '';
        const key = this.dataKey(data);
        const keyField = this.defaultKeyField();
        console.log('filter', filter)
        const contractKey = data.contractId;
        const next = RemoteCenter['getNextData' + ver](this.getSerivceCode(), key, keyField, contractKey, filter);
        this.addDatas([next]);
        return next;
    }

    async simpleCall(url, data, type) {
        return RemoteCenter.simpleCall(url, data, type);
    }
    
    getDataOptions(datas, nameField, keyField) {
        if (this._dictType == DictType.STATIC || this._dictType == DictType.TREE) {} else {
            if (datas && datas.length) {
                this.addDatas(datas);
            }
        }
        return {dataInfo:this, nameField:nameField, keyField:keyField};

        // if (this._dictType == DictType.STATIC || this._dictType == DictType.TREE) {
        //     datas = this.getDatas();
        // }
        // const options = mapDatas(datas, {value:keyField || this._dict.defaultKeyField(), label:nameField}, this);
        // // console.log('get options', this._code, options);
        // return options;
    }
    getFilteredOptions(filter, nameField, keyField, datas) {
        const options = mapDatas(filter ? this.match(filter) : datas || this.getDatas(), {value:keyField || this.defaultKeyField(), label:nameField}, this);
        return options;                                                                                                                                                                                                              
    }

    matchIndex(opt, value, not, ignocase, indexField) {
        const result = {};
        const keyField = this._childrenKeyField || this.defaultKeyField();
        this._dict.mapIndex((keys, index)=> {
            if (test(index, opt, value, not, ignocase)) {
                const datas = {};
                for (const [key, value] of Object.entries(keys)) {
                    const data = this._dict.getData(key);
                    datas[data[keyField]] = data;
                }
                union(result, datas);
            }
        }, indexField);
        return result;
    }

    matchData = function(opt, value, not, ignocase, field) {
        var result = {};
        if (this._dict.testKeyField(field)) {
            if ((opt == '==' && !not) || (opt == '!=' && not)) {
                result[value] = this._dict.getData(value, field);
                return result;
            } else if (opt == 'in' && !not) {
                for (var i in value) {
                    result[i] = this._dict.getData(i, field);
                }
                return result;
            }
        }
        this._dict.mapKey(function(data, key) {
            if (test(/*data.props(field)*/data[field], opt, value, not, ignocase)) {
                result[key] = data;
            }
        })
        return result;
    }
    
    matchExp(expObject) {
        if (expObject.testFunc) {
            var result = {};
            var owner = this;
            if (expObject.target) {
                this._dict.mapKey(function(data, key) {
                    console.log('map key', key);
                    if (expObject.testFunc(data, owner)) result[key] = data;
                })
            } else {
                this._dict.mapAll(function(data, key) {
                    if (expObject.testFunc(data, owner)) result[key] = data;
                })
            }
            return result;
        } else if (expObject.target) {
            if (this._dict.testIndexField(expObject.target)) return this.matchIndex(expObject.opt, expObject.value, expObject.not, expObject.ignocase, expObject.target);
            else return this.matchData(expObject.opt, expObject.value, expObject.not, expObject.ignocase, expObject.target);
        } else {
            if (expObject.opt == 'and') {
                return cross(this.matchExp(expObject.left), this.matchExp(expObject.right));
            } else if (expObject.opt == 'or') {
                return union(this.matchExp(expObject.left), this.matchExp(expObject.right));
            }
        }
        return null;
    }

    match(condition) {
        if (!condition) return this.getDatas();
        const keyfield = this._treeInfo ? this._childrenKeyField : this._dict.defaultKeyField();
        const matches = this.matchExp(ConditionAnalyzer.analyze(condition, keyfield, this._dict.getIndexMaps()));
        const result = [];
        if (this._keyList) {
            for (const key of this._keyList) {
                if (matches[key] != null) result.push(this._dict.getData(key, this._childrenKeyField || this.defaultKeyField()));
            }
        }  else {
            for (const key in matches) {
                result.push(this._dict.getData(key));
            }
        }
        return result;
    }

    filter(data, keyData) {
        const exp = [];
        const filterData = Object.assign({}, data, keyData);
        for (const [key, value] of Object.entries(filterData)) {
            if (key == 'token') continue;
            exp.push(key + '=' + JSON.stringify(value));
        }
        const condition = exp.join(' and ');
        return this.match(condition);
    }

    getAllChildrenKeys(key, keys) {
        if (!keys) keys = [];
        const childrenKeys = this._childrenKeyMap[key];
        if (childrenKeys && childrenKeys.length) {
            for (const childKey of childrenKeys) {
                keys.push(childKey);
                this.getAllChildrenKeys(childKey, keys);
            }
        }
        return keys;
    }

    async getKey(key) {
        if (!this._treeInfo) return key;
        const keys = [key];
        const datas = await this.loadStaticDatas();
        this.resetDatas(datas);
        this.getAllChildrenKeys(key, keys);
        // console.log('keys', keys);
        return keys
    }
}

export default DataInfo;